import { create } from 'zustand';

import { ZeeDocument } from '@/types/zee.document.type';

export interface ZeeDocumentState {
  zeeDocuments: Array<ZeeDocument> | undefined;
  setZeeDocuments: (zeeDocuments: Array<ZeeDocument>) => void;
}

const useZeeDocumentStore = create<ZeeDocumentState>((set) => ({
  zeeDocuments: undefined,
  setZeeDocuments: (zeeDocuments: Array<ZeeDocument>) =>
    set(() => ({ zeeDocuments })),
}));

export { useZeeDocumentStore };
